export function calcularFatorPotencia({ p, q }) {
    const fp = parseFloat((parseFloat(p) / Math.sqrt(Math.pow(parseFloat(p), 2) + Math.pow(parseFloat(q), 2))).toFixed(2));
    return fp;
}
